import React from "react";
import Header from "../Header";
import MenuBar from "../MenuBar";
import BusinessInfo from "./businessInfo";
import PersonalInfo from "./personalInfo";
import Footer from "../Footer";
import "../adminProfile/adminProfile.css";
import { useAuth } from "../../context/API_Client";
import { useLocation } from "react-router-dom";
import { EditButtonProvider } from "./EditButtonContext";
import { ToastContainer } from "react-toastify";

function AdminProfile(operationPermissions) {
  const { isAuthorizedPermission } = useAuth();
  const { state } = useLocation();
  const firstTime = state?.firstTime || false;

  return (
    <EditButtonProvider>
      <>
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section className="content">
            {isAuthorizedPermission(
              operationPermissions?.updateMerchantSetting
            ) && <BusinessInfo />}
            <PersonalInfo />
          </section>
        </div>
      </>
    </EditButtonProvider>
  );
}

export default AdminProfile;
